/* PortalStarted component */
import React from 'react';
import { useGet } from "seed/api";
import View from "components/tmisc/portal/started/Started.view";


/* The screen a client's project opens on while its brief is being gathered.
 
   The gathering used to be a wizard of ours (see ./prompt). It is the Onboarding
   assistant now — a flow like any other, running against this client's account.

   It is framed rather than rendered because it is a *different flow*: its own app,
   routes and views, while the presentation around it is already mounted on the
   client's. Two presentations cannot share one React tree, so the frame is what keeps
   them apart. The seat that lets this account run it is granted at signup (see the
   API's finish_onboarding); here only the address is fetched. */
const PortalStarted = ({ flow }) => {

  // Which project the assistant is being run for. It cannot work this out on its own —
  // it executes in a flow of ours, not in this one — so the portal leaves it where the
  // framed app can pick it up. Storage, not the frame's URL, because the two share an
  // origin and the app reads it once at mount rather than off its own address.
  sessionStorage.setItem("briefing_flow_id", flow.id);

  const reqOnboardingFlow = useGet("/flows/onboarding_flow");

  return <View
    isLoading={reqOnboardingFlow.loading}
    onboardingFlow={reqOnboardingFlow.data}
  />;

}

export default PortalStarted;
